
import useScrollProgress from "@/hooks/header_menu/useScrollProgress";

export const useProcessAnimation = (sectionId: string) => {
  const { progress } = useScrollProgress(sectionId);

  // Improved step animation calculation with better distribution
  const getStepProgress = (stepIndex: number) => {
    // Distribute the progress more evenly across all steps
    const stepStart = stepIndex * 0.15; // Start earlier for better visibility
    const stepEnd = stepStart + 0.25; // Longer animation window
    
    if (progress < stepStart) return 0;
    if (progress > stepEnd) return 1;
    
    // Smooth easing function
    const rawProgress = (progress - stepStart) / (stepEnd - stepStart);
    return Math.max(0, Math.min(1, rawProgress));
  };

  // Calculate which step should be active with improved logic
  const getActiveStep = (stepIndex: number) => {
    const stepTrigger = stepIndex * 0.12; // Earlier trigger point
    return progress >= stepTrigger;
  };

  return {
    progress,
    getStepProgress,
    getActiveStep
  };
};
